import App from './pages/base/App';

export default App;
